import React, { useState, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { metadataRoute } from '~/routes'
import { updateRecord, findRecord, clearState } from '~/store/modules/metadata';
import MetadatumRecord from '~/records/MetadatumRecord';

import CrudEdit from '~/containers/CrudEdit';
import FormFields from './components/FormFields';

export default function Edit() {
  const [record, setRecord] = useState(new MetadatumRecord());
  const dispatch = useDispatch();
  const { isLoading, current, errors } = useSelector(state => state.metadata);
  const { id } = useParams();

  useEffect(() => {
    dispatch( findRecord(id) );
    return () => {
      dispatch( clearState() )
    };
  }, [])

  useEffect(() => {
    if(current){
      setRecord( record.updateAttributes(current) )
    }
  }, [current])

  const onSubmit = useCallback(() => {
    const data = record.toParams();
    dispatch( updateRecord(id, data) );
  }, [record, id]);

  const handleChange = useCallback(attrs => {
    setRecord(record.updateAttributes(attrs));
  }, [record, setRecord]);

  return (
    <CrudEdit
      isLoading={isLoading}
      onSubmit={onSubmit}
      errors={{ errors }}
      breadcrumbs={[
        { path: metadataRoute.list.path, text: 'Metadados' },
        { text: 'Editando Metadado' },
      ]}
      footerActionsProps={{ isLoading, showSaveAndContinue: false }}
    >
      <FormFields
        record={record}
        onChange={handleChange}
      />
    </CrudEdit>
  );
}